export const encodeString = (str) => {
    return str.replace(/[\u00A0-\u9999<>&]/g, (i) => { return '&#'+i.charCodeAt(0)+';'})
}

export const decodeHtmlEntity = (str) => {
    return str.replace(/&#(\d+);/g, function(match, dec) {
      return String.fromCharCode(dec);
    });
  };